import { createSlice } from "@reduxjs/toolkit";

const changesExist = (current, changes) => {
    return (JSON.stringify(current) !== JSON.stringify(changes));
};

export const CalcSettingsSlice = createSlice({
    name:'calculation-settings',
    initialState: {
        dirty: false,
        error: false,
        current: {},
        changes: {}
    },
    reducers: {
        setSettings: (state, action) => {
            return {
                dirty: false,
                current: action.payload,
                changes: action.payload
            }
        },
        updateCalibrationSetting: (state, action) => {
            let calibration = JSON.parse(JSON.stringify(state.changes.calibration)); // make a copy of the state object being updated
            if(calibration){
                calibration[action.payload.property] = action.payload.value;
                
                let changesCopy = JSON.parse(JSON.stringify(state.changes));
                changesCopy = {
                    ...changesCopy,
                    calibration: calibration
                }
    
                return {    
                    ...state,
                    dirty: changesExist(state.current, changesCopy),
                    changes: {
                        ...changesCopy
                    }
                }
            } else {
                return {...state}
            }
        },
        updateDataFilterSetting: (state, action) => {
            let dataFilters = JSON.parse(JSON.stringify(state.changes.dataFilters)); // make a copy of the state object being updated
            if(dataFilters) {
                let filter = dataFilters.find(df => df.type === action.payload.type);
                if(filter){
                    if (action.payload.enabledState) {
                        filter.enabled = action.payload.value;
                    } else {
                        filter.attributes[action.payload.property] = action.payload.value;
                    }
                }

                let changesCopy = JSON.parse(JSON.stringify(state.changes));
                changesCopy = {
                    ...changesCopy,
                    dataFilters: dataFilters
                }

                return {    
                    ...state,
                    dirty: changesExist(state.current, changesCopy),
                    error: action.payload.error,
                    changes: {
                        ...changesCopy
                    }
                }
            } else {
                return {...state}
            }
        },
        updateStartStop: (state, action) => {
            let midPoint = action.payload.dataStart + ((action.payload.dataEnd - action.payload.dataStart) / 2);
            let info = JSON.parse(JSON.stringify(state.changes.info));
            if(info) {
                let start = Math.floor(action.payload.start);
                let stop = Math.floor(action.payload.stop); 

                if(start < 0) { start = 0; }
                if(stop < 0) { stop = 0; }

                // swap start/stop when the start is greater than stop
                if(start > stop) {
                    stop = start;
                    start = action.payload.stop;
                }

                //  Motor Positions
                //  Right           Left
                //  MachineStart    MotorStop
                //  MachineStop     MotorStart
                //  MotorStart      MachineStop
                //  MotorStop       MachineStart
                if(info.motorRight)
                {
                    // machine is less than midpoint
                    if(start < midPoint) {
                        info.machineStart = start;
                        if(stop < midPoint) {
                            info.machineStop = stop;
                        } else {
                            // the data is split between the machine and motor
                            info.machineStop = midPoint;
                            info.motorStart = midPoint;
                            info.motorStop = stop;
                        }
                    } else {
                        info.motorStart = start;
                        info.motorStop = stop;
                    }
                } else { // motor left
                    // motor is less than midpoint
                    if(start < midPoint) {
                        info.motorStop = start;
                        if(stop < midPoint) {
                            info.motorStart = stop;
                        } else {
                            // the data is split between the machine and motor
                            info.motorStart = midPoint;
                            info.machineStop = midPoint;
                            info.machineStart = stop;
                        }
                    } else {
                        info.machineStop = start;
                        info.machineStart = stop;
                    }
                }

                let changesCopy = JSON.parse(JSON.stringify(state.changes));
                changesCopy = {
                    ...changesCopy,
                    info: info
                }

                return {    
                    ...state,
                    dirty: changesExist(state.current, changesCopy),
                    error: action.payload.error,
                    changes: {
                        ...changesCopy
                    }
                }
            } else {
                return {...state}
            }
        }
    }
})

export const { setSettings, updateCalibrationSetting, updateDataFilterSetting, updateStartStop } = CalcSettingsSlice.actions

export default CalcSettingsSlice.reducer